import type { AccountRelatedRow } from '~/services/ContractingService';

import { toAccountContact } from '../Contacts/toAccountContact';

import type { AccountRelatedContact } from './types';

export function toAccountRelatedContact(row: AccountRelatedRow<'related_contacts'>): AccountRelatedContact {
  return {
    ...toAccountContact(row),
    accountName: row.contact_account?.name ?? null,
    accountRecordType: row.account_record_type,
    isActive: row.is_active ?? false,
    isPrimary: row.is_primary ?? false,
    roles: row.roles ?? [],
  };
}
